// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import AlrModel from '../../model/alr-model';
import AlrDTO from '../dto/alr-dto';
import dtoSchema from '../schemas/alr-schema';

export default abstract class AlrModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<AlrDTO>) {
    super();
    if (data) {
      this.pro = data.pro ?? undefined;
      this.ver = data.ver ?? undefined;
    }
  }
  /**
  */
  pro?: string;
  /**
  */
  ver?: string;

  static toModel(dto: DeepPartial<AlrDTO>): AlrModel;
  static toModel(dto: DeepPartial<AlrDTO> | undefined | null): AlrModel | undefined;
  static toModel(dto: DeepPartial<AlrDTO> | undefined | null): AlrModel | undefined {
    return dto ? new AlrModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<AlrModel> | AlrModel): AlrDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      pro: unwrapped.pro,
      ver: unwrapped.ver,
    } as AlrDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for AlrModel, can not map to AlrDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
